<template>
<w-settings-content-template>
  <div slot="content">
    <div v-show="!imageListFlag">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r10">이미지 폴더</div>
          <el-button class="mr-r4" type="primary" size="small" @click="clickNewFolder">새폴더</el-button>
          <el-button size="small" :disabled="!checkedFlag" @click="onDeleteImgGroup">삭제</el-button>
        </div>
        <w-search-field ref="searchField" width="250px" @search="onImgSearch" />
      </el-row>
      <hr class="mr-b20" style="margin-top:0px;" />
      <el-row :gutter="10" v-if="!showEmptyText">
        <!-- margin-bottom 삭제 0325 -->
        <w-img-box-for-group v-for="item in imgGroups" ref="imgBoxGroup" :key="item.customimagetypeId" :data="item" @dblclick-img="dblclickImg"
          @change-group-name="changeGroupName" @add-img-group="addImgGroup" @check-change="onCheckChange" />
      </el-row>
      <!-- SettingContentTemplate는 공통 컴포넌트여서 아래와 같이 style 수정 -->
      <div v-else-if="showEmptyText" style="margin-top: 240px; display: flex; justify-content: center; align-items: center; font-size: 16px;">
        {{this.emptyText}}
      </div>
    </div>
    <w-image-list v-show="imageListFlag" :active="imageListFlag" ref="imageList" :data="targetGroupInfo" @dblclick-img="dblclickImg" />
  </div>
</w-settings-content-template>
</template>

<script>
import { forEach, cloneDeep, findIndex, find, filter } from 'lodash';
import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WSearchField from '@/components/form/SearchField';
import WImgBoxForGroup from './components/ImgBoxForGroup';
import WImageList from './ImageList';

export default {
  name: 'WImageSettings',
  components: {
    WSettingsContentTemplate,
    WImgBoxForGroup,
    WImageList,
    WSearchField,
  },
  data() {
    return {
      imgGroups: [],
      imageListFlag: false,
      targetGroupInfo: {},
      newFolderIndex: 0,
      searchValue: '',
      checkedFlag: false,
      emptyText: '데이터 없음',
      showEmptyText: false,
    };
  },
  watch: {
    imageListFlag(to) {
      if (to) {
        this.reset();
      }
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.searchValue = '';
      OperationSettingsAPI.getImageGroupList().then((response) => {
        if (response.data.success) {
          this.imgGroups = response.data.data;
          this.imgGroupsOrigin = cloneDeep(this.imgGroups);
        }
      });
    },
    dblclickImg(payload) {
      // 컴포넌트 전환 및 api 호출
      if (!payload) {
        // 그룹 리스트로 돌아가기
        this.imageListFlag = false;
      } else {
        // 그룹 리스트 클릭
        this.imageListFlag = true;
        this.targetGroupInfo = payload;
        this.$nextTick(() => {
          this.$refs.imageList.loadData();
        });
      }
    },
    changeGroupName(params) {
      const target = '폴더명';
      const action = msgUtil.action.MODIFY;
      OperationSettingsAPI.setCustomImageGroup(params)
        .then((response) => {
          if (response.data.success) {
            const index = findIndex(this.imgGroupsOrigin, (item) => item.customimagetypeId === params.customimagetypeId);
            this.imgGroupsOrigin[index].customimagetypeName = params.customimagetypeName;
            this.$message(msgUtil.getResultMsgData(action, target, true));
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    // 새폴더 생성
    clickNewFolder() {
      this.newFolderIndex += 1;
      const newImgGroupData = {
        customimagetypeName: `새폴더#${this.newFolderIndex}`,
      };
      this.imgGroups.push(newImgGroupData);
    },
    // 새폴더 생성, 이름 수정 후  api 호출 및 로드 수행
    addImgGroup(customimagetypeName) {
      const param = {
        customimagetypeName,
      };
      OperationSettingsAPI.addCustomimageType(param).then((response) => {
        if (response.data.success) {
          this.loadData();
        }
      });
    },
    // 이미지 그룹을 삭제합니다.
    onDeleteImgGroup() {
      const params = [];
      // check
      forEach(this.$refs.imgBoxGroup, (item) => {
        if (item.checked) {
          params.push(item.data);
        }
      });
      if (params.length > 0) {
        const action = msgUtil.action.DELETE;
        const target = '폴더';
        this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
          OperationSettingsAPI.deleteCustomimageType(params)
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.loadData();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
        });
      } else {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.SELECT, '삭제할 폴더'));
      }
    },
    // 이미지 검색
    onImgSearch(searchValue) {
      const keyword = searchValue ? searchValue.toLowerCase() : false;
      const target = this.imgGroupsOrigin.filter((value) => value.customimagetypeName.toLowerCase().indexOf(keyword) > -1);
      this.imgGroups = target;
      // 검색결과 없을 경우 도움말
      if (!this.imgGroups.length) {
        this.showEmptyText = true;
      } else if (this.imgGroups.length) {
        this.showEmptyText = false;
      }
      if (keyword === false) { // 검색키워드 없을 경우
        this.imgGroups = this.imgGroupsOrigin;
        this.showEmptyText = false;
      }
    },
    onCheckChange(data, value) {
      // 현재 선택된 폴더의 checked flag 변경
      const findData = find(this.imgGroups, data);
      findData.checked = value;

      // 체크된 폴더가 하나라도 있을 경우 flag 변경
      const checkedList = filter(this.imgGroups, 'checked');
      this.checkedFlag = checkedList.length > 0;
    },
    reset() {
      if (!isEmpty(this.imgGroups)) {
        // 동일한 폴더를 조회하는 경우 선택이 유지되지 않도록 체크가 해제되도록 처리
        this.imgGroups = cloneDeep(this.imgGroupsOrigin);
      }
      this.$refs.searchField.clear();
      this.checkedFlag = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/ImageSettings/ImageSettingsView/index.vue